/**
 * LalaTent — mega-menu hover behavior.
 * On hover-capable devices, force <details> always-open (panel always rendered)
 * and toggle a `.is-active` class on the <details> to control visibility.
 * This decouples visibility from the <details> open/close mechanism, which
 * doesn't reliably trigger CSS transitions on every toggle.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 40;

  function isHoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function closeOthers(except) {
    document.querySelectorAll('header-menu details.mega-menu.is-active').forEach(function (d) {
      if (d !== except) d.classList.remove('is-active');
    });
  }

  function bind(menu) {
    if (menu.dataset.hoverBound === '1') return;
    menu.dataset.hoverBound = '1';

    var details = menu.querySelector('details.mega-menu');
    if (!details) return;
    var summary = details.querySelector('summary');

    // Force <details> always-open on hover-capable devices so the panel
    // stays in the render tree. Visibility is controlled via .is-active.
    if (isHoverCapable()) {
      details.setAttribute('open', '');
    }

    var openTimer = null;

    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    }

    function open(delay) {
      clearTimers();
      openTimer = setTimeout(function () {
        // Cursor may have already left the menu (and the entire header) before
        // this delayed open fires. If so, mouseleave on .header-wrapper will
        // have already run and found nothing to close — activating now would
        // strand the panel open with no way to dismiss it.
        if (!menu.matches(':hover')) return;
        closeOthers(details);
        details.classList.add('is-active');
      }, delay);
    }

    // Only mouseenter on a mega menu triggers anything. We deliberately do
    // NOT close on mouseleave — moving from a mega menu to a non-mega item
    // (Home, About Us) should keep the previously-open panel showing.
    // Closing happens via (1) entering a different mega menu, which calls
    // closeOthers, or (2) leaving the entire header wrapper (bindHeaderLeave).
    menu.addEventListener('mouseenter', function () {
      if (!isHoverCapable()) return;
      open(OPEN_DELAY);
    });

    if (summary) {
      // Click / Enter / Space toggles the panel (keyboard and click support
      // while <details> is forced open on hover-capable devices).
      summary.addEventListener('click', function (e) {
        if (!isHoverCapable()) return;
        e.preventDefault();
        // Mouse clicks are handled by hover; only keyboard-generated clicks
        // (Enter / Space report detail === 0) toggle the panel.
        if (e.detail !== 0) return;
        clearTimers();
        var willOpen = !details.classList.contains('is-active');
        closeOthers(details);
        details.classList.toggle('is-active', willOpen);
        summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    // Keyboard: open when focus moves into the panel links, close when focus
    // leaves the menu, Escape closes and returns focus to the summary.
    menu.addEventListener('focusin', function (e) {
      if (!isHoverCapable() || e.target === summary) return;
      closeOthers(details);
      details.classList.add('is-active');
    });

    menu.addEventListener('focusout', function (e) {
      if (!isHoverCapable()) return;
      if (e.relatedTarget && menu.contains(e.relatedTarget)) return;
      if (menu.matches(':hover')) return;
      details.classList.remove('is-active');
    });

    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !details.classList.contains('is-active')) return;
      details.classList.remove('is-active');
      if (summary) summary.focus();
    });
  }

  function bindAll() {
    document.querySelectorAll('header-menu').forEach(bind);
  }

  function bindHeaderLeave() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    header.addEventListener('mouseleave', function () {
      if (!isHoverCapable()) return;
      closeOthers(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll();
      bindHeaderLeave();
    });
  } else {
    bindAll();
    bindHeaderLeave();
  }

  document.addEventListener('shopify:section:load', function () {
    bindAll();
    bindHeaderLeave();
  });
})();
